// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__HLPWk","content":"Wrapper_content__O22Io","logo":"Wrapper_logo__85nbH"};